import { timepointLabel } from '../../api/know'
import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { admin } from '../../api/admin'
import { ApiError } from '../../api/client'

type Detail = Awaited<ReturnType<typeof admin.questionnaireResponse>>

export function AdminQuestionnaireDetailPage() {
  const { responseId } = useParams<{ responseId: string }>()
  const [data, setData] = useState<Detail | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    admin.questionnaireResponse(Number(responseId))
      .then(setData)
      .catch((e) => setError(e instanceof ApiError ? e.message : 'Error de red.'))
  }, [responseId])

  if (error) return <div className="banner-err">{error}</div>
  if (!data) return <p className="text-sm text-text-muted">Cargando…</p>

  return (
    <section>
      <p>
        <Link to="/admin/questionnaires" className="text-sm text-text-muted">
          ← Cuestionarios
        </Link>
      </p>
      <h1>
        {data.code}{' '}
        {data.timepoint && data.timepoint !== 'unica' && (
          <span className="tag normal-case tracking-normal align-middle">
            {timepointLabel(data.timepoint)}
          </span>
        )}{' '}
        <span className="text-sm text-text-muted">#{data.id}</span>
      </h1>
      {data.definition && (
        <p className="text-sm text-text-muted">{data.definition.name_es}</p>
      )}

      <h2>Metadatos</h2>
      <div className="table-wrap">
      <table>
        <tbody>
          <tr>
            <th>Usuario</th>
            <td>
              {data.user ? (
                <Link to={`/admin/users/${data.user.id}`}>
                  {data.user.username}
                </Link>
              ) : (
                '—'
              )}
            </td>
          </tr>
          <tr>
            <th>Nombre (form)</th>
            <td>{data.submitted_name || '—'}</td>
          </tr>
          <tr>
            <th>Email (form)</th>
            <td>{data.submitted_email || '—'}</td>
          </tr>
          <tr>
            <th>Momento</th>
            <td>{timepointLabel(data.timepoint)}</td>
          </tr>
          <tr>
            <th>Enviado</th>
            <td>{new Date(data.submitted_at).toLocaleString('es-AR')}</td>
          </tr>
          <tr>
            <th>IP</th>
            <td className="text-text-muted">{data.ip || '—'}</td>
          </tr>
          <tr>
            <th>User agent</th>
            <td className="text-text-muted text-xs">
              {data.user_agent || '—'}
            </td>
          </tr>
        </tbody>
      </table>
      </div>

      <h2>Puntajes</h2>
      <div className="grid grid-cols-2 gap-md sm:grid-cols-3">
        {data.scores.subscales &&
          Object.entries(data.scores.subscales).map(([k, s]) => (
            <div key={k} className="stat-card">
              <div className="stat-card-label">{s.label}</div>
              <div className="stat-card-value">
                {s.raw} <span className="text-sm font-normal text-text-muted">/ {s.max}</span>
              </div>
              <div className="mt-xs text-xs text-text-muted">
                rango {s.min}–{s.max}
              </div>
            </div>
          ))}
        {data.scores.total && (
          <div className="stat-card border-primary">
            <div className="stat-card-label text-primary">
              {data.scores.total.label}
            </div>
            <div className="stat-card-value">
              {data.scores.total.raw}{' '}
              <span className="text-sm font-normal text-text-muted">
                / {data.scores.total.max}
              </span>
            </div>
          </div>
        )}
      </div>

      <h2>Respuestas por ítem</h2>
      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Ítem</th>
              <th>Subescala</th>
              <th className="text-right">Valor</th>
              <th>Etiqueta</th>
            </tr>
          </thead>
          <tbody>
            {data.items_view.map((it) => (
              <tr key={it.id}>
                <td>{it.id}</td>
                <td>
                  {it.text ?? '(definición no encontrada)'}
                  {it.reverse && <span className="tag ml-1">inverso</span>}
                </td>
                <td>{it.subscale || '—'}</td>
                <td className="text-right font-bold">{it.value ?? '—'}</td>
                <td className="text-text-muted">{it.label || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  )
}
